import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SelectedPatientService {
  private readonly STORAGE_KEY = 'idPatient';
  private readonly PATIENT_TYPE_KEY = 'patientType';

  private selectedPatientIdSubject: BehaviorSubject<number | null> =
    new BehaviorSubject<number | null>(this.getStoredPatientId());

  private patientTypeSubject: BehaviorSubject<'adulte' | 'enfant' | null> =
    new BehaviorSubject<'adulte' | 'enfant' | null>(this.getStoredPatientType());

  selectedPatientId$ = this.selectedPatientIdSubject.asObservable();
  patientType$ = this.patientTypeSubject.asObservable();

  constructor() {}

  private getStoredPatientId(): number | null {
    const storedId = localStorage.getItem(this.STORAGE_KEY);
    return storedId ? Number(storedId) : null;
  }

  private getStoredPatientType(): 'adulte' | 'enfant' | null {
    const storedType = localStorage.getItem(this.PATIENT_TYPE_KEY);
    return storedType as 'adulte' | 'enfant' | null;
  }

  setSelectedPatientId(id: number | null): void {
      console.log('=== setSelectedPatientId ===', id);
      console.trace();
      if (id === null) {
          localStorage.removeItem(this.STORAGE_KEY);
      } else {
          localStorage.setItem(this.STORAGE_KEY, id.toString());
      }
      this.selectedPatientIdSubject.next(id);
  }

  getSelectedPatientId(): number | null {
    return this.selectedPatientIdSubject.value;
  }

  setPatientType(type: 'adulte' | 'enfant' | null): void {
    if (type === null) {
      localStorage.removeItem(this.PATIENT_TYPE_KEY);
    } else {
      localStorage.setItem(this.PATIENT_TYPE_KEY, type);
    }
    
    this.patientTypeSubject.next(type);
  }

  getPatientType(): 'adulte' | 'enfant' | null {
    return this.patientTypeSubject.value;
  }

  // Alternative method if you prefer to keep them separate
  clearSelectedPatientId(): void {
    this.setSelectedPatientId(null);
  }

  clearPatientType(): void {
    this.setPatientType(null);
  }

  // Clear both patient ID and type
  clearAll(): void {
    this.clearSelectedPatientId();
    this.clearPatientType();
  }

  clearAllSilent(): void {
      console.trace('clearAllSilent called'); // shows full call stack
      localStorage.removeItem(this.STORAGE_KEY);
      localStorage.removeItem(this.PATIENT_TYPE_KEY);
      this.selectedPatientIdSubject.next(null);
      this.patientTypeSubject.next(null);
  }
}